export default __webpack_public_path__ + "static/media/beach_3-large.acf966c7.jpg";